import React from "react"
import { FooterWrapper, FooterText } from "../theme"

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterText>&copy; Books App 2022</FooterText>
    </FooterWrapper>
  )
}

export default Footer